import React, { useState, useEffect } from 'react';
import { Button } from '@cordata/buffet';

export type SortDirection = 'ascending' | 'descending' | 'none';

class Direction {
  name: SortDirection;
  next?: Direction;
  icon: string;

  constructor(name: SortDirection, icon: string, next?: Direction) {
    this.name = name;
    this.next = next;
    this.icon = icon;
  }
}

interface SortButtonProps {
  text: string;
  onToggle: Function;
  defaultDirection?: SortDirection;
}

const SortButton = (props: SortButtonProps) => {
  const ascending = new Direction('ascending', 'sort-numeric-down', undefined);
  const descending = new Direction('descending', 'sort-numeric-up-alt', ascending);
  const none = new Direction('none', '', ascending);
  ascending.next = descending;

  const [direction, setDirection]: [Direction, Function] = useState(none);

  useEffect(() => {
    if (props.defaultDirection === 'ascending') {
      setDirection(ascending);
    } else if (props.defaultDirection === 'descending') {
      setDirection(descending);
    }
  }, []);

  useEffect(() => {
    props.onToggle(direction.name);
  }, [direction]);

  return (
    <Button
      size="sm"
      outline
      color="light"
      icon={direction.icon}
      onClick={() => setDirection(direction.next)}
    >
      { props.text }
    </Button>
  );
};

SortButton.defaultProps = {
  defaultDirection: undefined,
};

export default SortButton;
